const SALA_DAENG_EMAIL_DOMAIN = "@sala-daeng.com";

// ใช้กำหนดสิทธิ์เครื่องมือที่สงวนไว้ให้ทีมงาน Sala Daeng เท่านั้น
// (แยกจาก role ของบริษัทลูกค้า เช่น isAdmin / isDeveloper)
export default function isSalaDaengEmail(email) {
  if (typeof email !== "string") return false;
  return email.trim().toLowerCase().endsWith(SALA_DAENG_EMAIL_DOMAIN);
}
